import React, { useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import {
  CLOSE,
  CHOICE_ROUTE_WARNING_MESSAGE_DESCRIPTION_$,
  CHOICE_ROUTE_WARNING,
  CHOICE_ROUTE_WARNING_TITLE,
} from '../../../constants/strings';
import { Text, View } from '../../Base';
import warningTextModal from '../../styles/warningTextModal';
import { formatMessage } from '../../../utils/string';

const useStyles = makeStyles(() => warningTextModal);

const ChoiceRouteWarning = ({ open, onClose, choiceRoute }) => {
  const classes = useStyles();
  const warningString = useMemo(
    () =>
      formatMessage(CHOICE_ROUTE_WARNING_MESSAGE_DESCRIPTION_$, choiceRoute),
    [choiceRoute]
  );

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={CHOICE_ROUTE_WARNING_TITLE.toUpperCase()}
      actions={
        <>
          <Button minWidthZero onClick={onClose} className={classes.blueButton}>
            {CLOSE}
          </Button>
        </>
      }
    >
      <View className={classes.column}>
        <Text className={classes.text} style={{ paddingBottom: '16px' }}>
          {CHOICE_ROUTE_WARNING}
        </Text>
        <Text className={clsx(classes.text, classes.noPadding)}>
          {warningString}
        </Text>
      </View>
    </SimpleModal>
  );
};

export default ChoiceRouteWarning;
